import { Box, Container } from '@mantine/core';
import { Outlet, useLocation } from 'react-router-dom';
import { useSideBarStyle } from './components/Style';
import { useNonAuthLayoutContainerStyles } from './components/style';
import { ROUTES } from '../config/RoutesName';

export default function NonAuthLayout() {
  const { classes, cx } = useSideBarStyle();

  const { classes: nonAuthLayoutClasses } = useNonAuthLayoutContainerStyles();
  const { pathname } = useLocation();

  return (
    <>
      <Box w={'45%'} className={classes.mainWrapper}></Box>

      <Container
        className={`${nonAuthLayoutClasses.container} ${
          pathname === ROUTES.HOME && process.env.NODE_ENV === 'production' && !window.location.host.includes('dev')
            ? nonAuthLayoutClasses.containerRoot
            : ''
        }`}>
        <Outlet />
      </Container>
    </>
  );
}
